/**
 * @fileoverview POST handler for the "/:app_group_id/generative_ai/canvas_qa/cancel" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdCanvasQaCancelCacheKeys } from "./constants";
import type {
  GenerativeAiAppGroupIdCanvasQaCancelResult,
  PostGenerativeAiAppGroupIdCanvasQaCancelProps,
} from "./types";

export const postGenerativeAiAppGroupIdCanvasQaCancel = reactQueryMutationAdapter(
  generativeAiAppGroupIdCanvasQaCancelCacheKeys,
  (props: PostGenerativeAiAppGroupIdCanvasQaCancelProps): Promise<GenerativeAiAppGroupIdCanvasQaCancelResult> => {
    return fetch(
      `/${props.appGroupId}/generative_ai/canvas_qa/cancel`,
      "POST",
      { job_token: props.jobToken },
      undefined,
      {
        // Cancellation is best-effort: the run hook settles the UI locally, so
        // a failed cancel POST must not surface a blocking fetch-error modal.
        propagateFetchRequestError: false,
      }
    );
  }
);
